import { Component, Input } from '@angular/core';

@Component({
	selector: 'ws-download-button',
	templateUrl: './download-button.component.html',
	styleUrls: ['./download-button.component.scss'],
})
export class DownloadButtonComponent {
	@Input() url!: () => Promise<string>;

	constructor() {}

	async download() {
		const url = await this.downloadUrl();

		if (!!url) {
			window.open(url, '_blank');
		}
	}

	private async downloadUrl(): Promise<string> {
		if (!this.url) {
			return '';
		}

		return this.url();
	}
}
